// extracted by mini-css-extract-plugin
export var numpadContainer = "_ok-1";
export var phoneButton = "_ok-0";